import { useMemo } from 'react'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { getLocaleFromPath } from './locale-utils'
import type { Locale } from './locale-utils'

// Re-export everything from locale-utils so existing direct imports from this file still work
export type { Locale } from './locale-utils'
export {
  getLocaleFromParams,
  getLocaleFromPath,
  getLocaleSectionForRedirectPath,
  getPotentialLocaleFromPath,
  isFirstPathParamLocale,
  getLocaleOrDefault,
} from './locale-utils'

type UseLocaleResponse = {
  locale: Locale
}

export const useLocale = (): UseLocaleResponse => {
  const { asPath } = useSafeRouter()
  return useMemo(() => {
    return {
      locale: getLocaleFromPath(asPath) as Locale,
    }
  }, [asPath])
}
